import React, { useState, useEffect } from 'react'
import {
  Table,
  Button,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Tooltip,
  Popconfirm,
  Form,
} from 'antd'
import 'antd/dist/antd.css'
import {
  EditOutlined,
  DeleteOutlined,
  ReloadOutlined,
  UserOutlined,
} from '@ant-design/icons'
import apiRequest from '../hooks/ApiRequest'
import { toast } from 'react-toastify'
import { useHistory, useLocation } from 'react-router-dom'
import CommonSearch from '../hooks/Search'

const Users = ({ form }) => {
  const [loading, setLoading] = useState(false)
  const [users, setUsers] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [nationalID, setNationalID] = useState('')
  const history = useHistory()
  const location = useLocation()
  const { getFieldDecorator, setFieldsValue, resetFields, validateFields } = form

  const fetchUsers = async () => {
    setLoading(true)
    try {
      const resp = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/getAllUsers`,
        'GET',
      )

      var usersWithoutSuperAdmin = resp.data.filter(function (el) {
        return el.role !== 'SuperAdmin'
      })

      setUsers(usersWithoutSuperAdmin ?? [])
    } catch (err) {
      console.error(err)
      toast.error('Could not load users')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const passwordUpdated = params.get('passwordUpdated')

    fetchUsers()

    if (passwordUpdated === 'true') {
      toast.success('Password updated successfully')
      history.replace('/users') // Clean the URL
    }
  }, [])

  const openEdit = user => {
    setFieldsValue({
      id: user.id,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      mobileNumber: user.mobileNumber,
    })
    setModalVisible(true)
  }

  const handleSave = () => {
    validateFields(async (err, values) => {
      if (err) return
      try {
        await apiRequest(
          `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/user/update`,
          'POST',
          values,
        )
        toast.success('User updated')
        setModalVisible(false)
        resetFields()
        fetchUsers()
      } catch {
        toast.error('Failed to update user')
      }
    })
  }

  const handleDelete = async (id, role) => {
    let apiUrl
    if (
      role === 'Customer' ||
      role === 'Broker' ||
      role === 'InsurerAdmin' ||
      role === 'MasterBroker' ||
      role === 'UnderWriter'
    ) {
      apiUrl = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/user/delete-with-policy-check/${role}/${id}`
    } else {
      apiUrl = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/user/delete/${id}`
    }
    try {
      const res = await apiRequest(apiUrl, 'POST')
      if (res.data?.success) {
        toast.success('User deleted')
        fetchUsers()
      } else {
        toast.error(res.data?.message || 'Delete failed')
      }
    } catch {
      toast.error('Error deleting user')
    }
  }

  const handleSetPassword = async email => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/create-encrypted-email-token/${email}`,
        'GET',
        { email },
      )
      if (res.success) {
        const { encryptedEmail, encryptedToken } = res.data
        history.push(
          `/set-password?${encryptedToken}&&${encryptedEmail}&&red=0`,
        )
      } else {
        toast.error('Failed to create reset link')
      }
    } catch (err) {
      console.error(err)
      toast.error('Error creating reset link')
    }
  }

  const columns = [
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
      ellipsis: true,
      width: 20,
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
      ellipsis: true,
      width: 20,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      ellipsis: true,
      width: 20,
    },
    {
      title: 'Phone',
      dataIndex: 'mobileNumber',
      key: 'mobileNumber',
      ellipsis: true,
      width: 20,
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      ellipsis: true,
      width: 20,
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 240,
      render: (_, record) => (
        <div style={{ display: 'flex', gap: 8 }}>
          <Tooltip title="Edit">
            <Button type="primary" onClick={() => openEdit(record)}>
              <EditOutlined />
            </Button>
          </Tooltip>
          <Popconfirm
            title="Delete this user?"
            onConfirm={() => handleDelete(record.id, record?.role)}>
            <Tooltip title="Delete">
              <Button type="danger">
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
          <Tooltip title="Set Password">
            <Button
              size="small"
              onClick={() => handleSetPassword(record.email)}>
              Reset Password
            </Button>
          </Tooltip>
        </div>
      ),
    },
  ]
  const handleSearch = value => {
    const filterTable = users.filter(o =>
      Object.keys(o).some(k =>
        String(o[k]).toLowerCase().includes(value.toLowerCase()),
      ),
    )
    setUsers(filterTable)
  }
  const ClearSerach = () => {
    setNationalID('')
    setUsers(users)
    fetchUsers()
  }
  return (
    <div className="ant-layout-content dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={12}>
            <div className="section-top-heading">
              <h3
                style={{
                  color: '#0C1362',
                  fontWeight: '600',
                  fontSize: '20px',
                }}>
                Users
              </h3>
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={7}>
            <div className="item-search">
              <CommonSearch
                value={nationalID}
                onChange={e => setNationalID(e.target.value)}
                onSearch={handleSearch}
                onClear={ClearSerach}
              />
            </div>
          </Col>
          <Col xs={24} sm={24} md={3} lg={2}>
            <div className="create-quotation">
              <Button
                type="primary"
                onClick={() => handleSearch(nationalID)}
                style={{ marginLeft: 10 }}>
                Search
              </Button>
            </div>
          </Col>
        </Row>
      </div>
      <Spin spinning={loading}>
        <Table
          dataSource={users}
          columns={columns}
          rowKey="id"
          scroll={{ x: 'max-content' }}
        />
      </Spin>
      <Modal
        title="Edit User"
        visible={modalVisible}
        onCancel={() => {
          setModalVisible(false)
          resetFields()
        }}
        onOk={handleSave}
        okText="Save">
        <Form layout="vertical">
          {getFieldDecorator('id')(<Input type="hidden" />)}
          <Form.Item label="First Name">
            {getFieldDecorator('firstName', {
              rules: [{ required: true }],
            })(<Input />)}
          </Form.Item>
          <Form.Item label="Last Name">
            {getFieldDecorator('lastName', {
              rules: [{ required: true }],
            })(<Input />)}
          </Form.Item>
          <Form.Item label="Email">
            {getFieldDecorator('email', {
              rules: [{ type: 'email' }],
            })(<Input />)}
          </Form.Item>
          <Form.Item label="Mobile">
            {getFieldDecorator('mobileNumber')(<Input />)}
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}

export default Form.create({ name: 'user_form' })(Users)
